export default {
  '***': {
    '***': [
      {
        "id": 2,
        "label": "Home/Renters",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 3,
        "label": "Auto",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 4,
        "label": "Bundle",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 5,
        "label": "RV",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [],
        "tooltip": ""
      },{
        "id": 6,
        "label": "Boat",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [],
        "tooltip": ""
      },{
        "id": 7,
        "label": "Motorcycle",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [],
        "tooltip": ""
      },{
        "id": 10,
        "label": "",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [11,12,13,14],
        "tooltip": ""
      },{
        "id": 11,
        "label": "Awards/Accolades",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "Refers to any reference of awards or rankings, 3rd party or commissioned research based."
      },{
        "id": 12,
        "label": "Customer Service",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "Refers to a primary focus on customer service"
      },{
        "id": 13,
        "label": "General Reputation",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "Refers to any ad that focuses on a brand's general reputation, but does not mention any products"
      },{
        "id": 14,
        "label": "Sponsorship",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": ""
      },{
        "id": 20,
        "label": "Creative Style",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [21,22,23,24,25,26],
        "tooltip": ""
      },{
        "id": 21,
        "label": "Humorous",
        "selected": 0,
        "collapse": 0,
        "parent": 20,
        "children": [],
        "tooltip": `The intent of the ad is to make you laugh. Formerly "Contains Humor" under "other Ad Features" for BE`
      },{
        "id": 22,
        "label": "Emotional",
        "selected": 0,
        "collapse": 0,
        "parent": 20,
        "children": [],
        "tooltip": "The intent of the ad is to elicit sad or heartwarming emotion"
      },{
        "id": 23,
        "label": "Family Focus (e.g. kids, families, etc.)",
        "selected": 0,
        "collapse": 0,
        "parent": 20,
        "children": [],
        "tooltip": "Includes any ads focusing on families or children. Does not include couples only"
      },{
        "id": 24,
        "label": "Older Focus (e.g. older adults)",
        "selected": 0,
        "collapse": 0,
        "parent": 20,
        "children": [],
        "tooltip": "Includes any ads with a particular focus on adults 60+"
      },{
        "id": 25,
        "label": "Diverse Audience Focus",
        "selected": 0,
        "collapse": 0,
        "parent": 20,
        "children": [],
        "tooltip": "Ad has an intentional focus on people from multiple ethnic or cultural backgrounds"
      },{
        "id": 26,
        "label": "Branding in First 5 seconds ",
        "selected": 0,
        "collapse": 0,
        "parent": 20,
        "children": [],
        "tooltip": "The advertising brand is shown or spoken in the first 5 seconds"
      },{
        "id": 31,
        "label": "Narrative",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [],
        "tooltip": "Ad follows a story trajectory, even if short. "
      },{
        "id": 32,
        "label": "Split Narrative",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [],
        "tooltip": "Ad features two or more distinct narrative threads interwoven or presented in parallel within the same ad. Each thread typically involves different characters, settings, or perspectives."
      },{
        "id": 33,
        "label": "Montage",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [],
        "tooltip": "series of disjointed scenes or scenes with unclear sequence of events (e.g. a narrative montage with huge gaps of time between scenes)"
      },{
        "id": 34,
        "label": "Non-Narrative",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [],
        "tooltip": "Ad does not feature narrative, usually focusing on a product with few or no actual filmed scenes"
      },{
        "id": 40,
        "label": "Music",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [41,42],
        "tooltip": ""
      },{
        "id": 41,
        "label": "Music Present Indicator",
        "selected": 0,
        "collapse": 0,
        "parent": 40,
        "children": [],
        "tooltip": "any and all"
      },{
        "id": 42,
        "label": "Popular Song",
        "selected": 0,
        "collapse": 0,
        "parent": 40,
        "children": [],
        "tooltip": `Refers to an identifiable song - either lyrics or instrumental. Formerly "Creative Style" in AdPi Coding`
      },{
        "id": 50,
        "label": "Personas Present",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [51,52,53,54],
        "tooltip": ""
      },{
        "id": 51,
        "label": "Celebrity",
        "selected": 0,
        "collapse": 0,
        "parent": 50,
        "children": [],
        "tooltip": "character introduced as celebrity or recongizable by coder - does not apply to celebrities playing characters unless their indenpendent fame is explicitly leveraged/referenced"
      },{
        "id": 52,
        "label": "Spokesperson",
        "selected": 0,
        "collapse": 0,
        "parent": 50,
        "children": [],
        "tooltip": "Includes both celebrity and non-celebrity spokespeople. Looking directly at camera"
      },{
        "id": 53,
        "label": "Brand Character",
        "selected": 0,
        "collapse": 0,
        "parent": 50,
        "children": [],
        "tooltip": "character or mascot exclusive to a particular brand"
      },{
        "id": 54,
        "label": "Company official/owner",
        "selected": 0,
        "collapse": 0,
        "parent": 50,
        "children": [],
        "tooltip": "character must be introduced as an actual official and not an actor"
      },{
        "id": 60,
        "label": "Narration",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [61,62],
        "tooltip": ""
      },{
        "id": 61,
        "label": "People on camera",
        "selected": 0,
        "collapse": 0,
        "parent": 60,
        "children": [],
        "tooltip": "character must be seen speaking"
      },{
        "id": 62,
        "label": "Voiceover narration",
        "selected": 0,
        "collapse": 0,
        "parent": 60,
        "children": [],
        "tooltip": "An off-screen narrator is featured."
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/Insurance/config/components/selection/Search/tagHierarchy.js